import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { Box, Checkbox, FormControlLabel, FormHelperText, Typography } from "@mui/material";
import React from "react";
import { IDisclaimer } from "../../routes/paid-medical-leave-request/PaidMedicalLeaveRequestModels";
import { ITheme } from "../../utils/theme";

interface IYesNoCheckboxGroupProps {
  label: string;
  fieldKey: string;
  value: boolean | null;
  onChange: (key: string, value: boolean | null) => void;
  required?: boolean;
  error?: JSX.Element | string,
  onShowDisclaimer?: (dislaimer: IDisclaimer) => void;
  disclaimer?: IDisclaimer,
  disclaimerLabel?: string
}

export const YesNoCheckboxGroup: React.FC<IYesNoCheckboxGroupProps> = ({
  label,
  fieldKey,
  value,
  onChange,
  required = false,
  error = '',
  onShowDisclaimer,
  disclaimer,
  disclaimerLabel
}) => (
  <Box sx={{ mb: 1 }}>
    <Box component="span" sx={{ display: 'inline' }}>
      {label}
      {required && (
        <Box
          component="span"
          sx={{
            color: (theme: ITheme) => theme.palette.red.A700,
            ml: 0.5,
          }}
        >
          *
        </Box>
      )}
      {disclaimer && onShowDisclaimer && (
        <Box
          component="span"
          onClick={() => onShowDisclaimer(disclaimer)}
          sx={{
            display: 'inline-flex',
            alignItems: 'center',
            cursor: 'pointer',
            ml: 0.5,
            position: 'relative',
            top: '3px'
          }}
        >
          <HelpOutlineIcon sx={{ color: 'corporateBlue', mr: 1 }} />
          {disclaimerLabel && <Typography sx={{ color: (theme: ITheme) => theme.palette.corporateBlue }}>{
            disclaimerLabel}
          </Typography>}
        </Box>
      )}
    </Box>
    <Box>
      <FormControlLabel
        sx={{ mr: 2, color: (theme: ITheme) => theme.palette.corporateBlue }}
        control={
          <Checkbox
            sx={{ mr: 2, color: (theme: ITheme) => (error ? theme.palette.red.A700 : theme.palette.corporateBlue) }}
            checked={value === true}
            onChange={(e) => onChange(fieldKey, e.target.checked ? true : null)}
          />
        }
        label="Yes"
      />
      <FormControlLabel
        sx={{ color: (theme: ITheme) => theme.palette.corporateBlue }}
        control={
          <Checkbox
            sx={{ mr: 2, color: (theme: ITheme) => (error ? theme.palette.red.A700 : theme.palette.corporateBlue) }}
            checked={value === false}
            onChange={(e) => onChange(fieldKey, e.target.checked ? false : null)}
          />
        }
        label="No"
      />
    </Box>
    {error && <FormHelperText
      component={'div'}
      error={!!error}
    >
      Indicate your answer.
    </FormHelperText>}
  </Box>
);
